module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training.b7c60bba.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training.png
// module id = 3809
// module chunks = 11